import { render, staticRenderFns } from "./friend-item.vue?vue&type=template&id=0e5cffba&scoped=true"
import script from "./friend-item.vue?vue&type=script&lang=js"
export * from "./friend-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5cffba",
  null
  
)

export default component.exports